import type React from 'react';
import type { VectorArt, A11y, Direction } from '@wix/editor-react-types';
import type { AriaProps } from '@wix/editor-elements-types/a11y';

// Inlined from @wix/thunderbolt-becky-types LinkProps
export interface ButtonLinkProps {
  href?: string;
  target?: '_blank' | '_self';
  rel?: string;
  linkPopupId?: string;
  anchorDataId?: string | { id: string };
  anchorCompId?: string;
}

export enum IconAnimationTriggers {
  HOVER = 'hover',
}

export type IStylableButtonCorvidStyleStateProps = {
  hasBackgroundColor?: boolean;
  hasBorderColor?: boolean;
  hasBorderRadius?: boolean;
  hasBorderWidth?: boolean;
  hasIconColor?: boolean;
  hasColor?: boolean;
};

export type IStylableButtonCorvidStateProps =
  IStylableButtonCorvidStyleStateProps & {
    hover?: IStylableButtonCorvidStyleStateProps;
    disabled?: IStylableButtonCorvidStyleStateProps;
    iconSvgString?: string | null;
    iconCollapsed?: boolean;
    iconAnimationTriggers?: Array<IconAnimationTriggers> | [];
  };

export type StylableButtonSemanticClassNames = {
  root: string;
  buttonIcon: string;
  buttonLabel: string;
};

// Inlined from @wix/editor-elements-library AnimatedSvg.types
export type AnimatedSvgRef = {
  runAnimationForward: () => void;
  runAnimationBackward: () => void;
};

export interface AnimatedIconElementProps {
  svg?: VectorArt;
  duration?: number;
}

export interface ElementProps {
  animatedIcon?: AnimatedIconElementProps;
}

export type ButtonProps = {
  link?: ButtonLinkProps;
  type?: 'button' | 'submit';
  label?: string;
  disabled?: boolean;
  className?: string;

  direction?: Direction;
  id?: string;
  onClick?: () => void;
  elementProps?: ElementProps;
  a11y?: A11y;
  corvid?: IStylableButtonCorvidStateProps;
  compPreviewState?: string | null;
  reportBiOnClick?: React.MouseEventHandler;
  preventLinkNavigation?: boolean;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  onDblClick?: React.MouseEventHandler;
  onFocus?: (event: React.FocusEvent) => void;
  onBlur?: (event: React.FocusEvent) => void;
  isIconAnimated?: boolean;
  isQaMode?: boolean;
  fullNameCompType?: string;
  lang?: string;
  ariaAttributes?: AriaProps;
  wix?: {
    presetsWrapperProps?: Record<string, any>;
  };
};
